import { RadioCard, Flex, Text, Heading } from '@buffer-mono/popcorn'

import type { Suggestion } from '../../hooks/useCreateFeed'
import { FeedItemIcon } from '../FeedIcon/FeedIcon'

import styles from './SuggestedFeedCard.module.css'

import type { JSX } from 'react'

type Props = {
  suggestion: Suggestion
}

export const SuggestedFeedCard = (props: Props): JSX.Element => {
  return (
    <RadioCard value={props.suggestion.url} className={styles.radioCard}>
      <FeedItemIcon
        feedName={props.suggestion.title}
        url={props.suggestion.url}
        size="large"
      />
      <Flex direction="column" fullWidth className={styles.content}>
        <Heading size="small" className={styles.title}>
          {props.suggestion.title}
        </Heading>
        <Text truncate size="sm" color="subtle" className={styles.url}>
          {props.suggestion.url}
        </Text>
      </Flex>
    </RadioCard>
  )
}
